import { Alert, Link, Snackbar } from '@mui/material';
import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { alertActionClick, hideAlert } from 'reducer/rootReducer';
import { RootState } from 'store';
import { DURATION_HIDE_ALERT } from 'utils/constants';

const AppAlert: FC = () => {
    const dispatch = useDispatch();

    const alertState = useSelector((state: RootState) => state.common.alert);

    const handleCloseAlert = () => {
        dispatch(hideAlert());
    };

    const handleAlertAction = () => {
        if (alertState.actionType) {
            dispatch(alertActionClick(alertState.actionType));
        }
        dispatch(hideAlert());
    };

    return (
        <Snackbar
            open={alertState.status}
            autoHideDuration={alertState.durations || DURATION_HIDE_ALERT}
            onClose={handleCloseAlert}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert
                severity={alertState.type}
                variant="standard"
                sx={{
                    fontFamily: 'Meiryo',
                    fontWeight: '400',
                    fontSize: '16px',
                    lineHeight: '24px',
                }}
            >
                {alertState.message}
                {alertState?.actionText && (
                    <>
                        {' '}
                        <Link
                            component="button"
                            underline="always"
                            onClick={handleAlertAction}
                            sx={{ fontSize: '16px' }}>
                            {alertState.actionText}
                        </Link>
                    </>
                )}
            </Alert>
        </Snackbar>
    );
};

export default AppAlert;
